import React, { KeyboardEvent } from 'react';

import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { useHomeQuickLinks } from 'components/Mobile/pages/home/hooks/useHomeQuickLinks';

import classes from './searchText.module.scss';

export const SearchText = () => {
    const [searchText, setSearchText] = React.useState('');
    const { goToQuickLink } = useHomeQuickLinks();

    const handleSearchClick = () => {
        if (searchText === '') return;
        goToQuickLink({ cardSearch: searchText });
    };

    const handleSearchEnterClick = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && searchText !== '') {
            goToQuickLink({ cardSearch: searchText });
        }
    };
    return (
        <TextInput
            className={classes.searchBox}
            placeholder={'Search by activity name or id'}
            onClear={() => {
                setSearchText('');
            }}
            onChange={(e) => {
                setSearchText(e.target.value);
            }}
            value={searchText}
            maxLength={300}
            onKeyDown={handleSearchEnterClick}
            searchable={true}
            onSearch={handleSearchClick}
        />
    );
};
